export default "__VITE_ASSET__vPi1y_IY__"